import React from 'react';

interface AstuteSearchBreadcrumbProps {
    currentRoot: string;
    categoryPath: string;
    subCategoryPath: string;
    searchResponse: any;
}

export const AstuteSearchBreadcrumb = (props: AstuteSearchBreadcrumbProps) => {
    return (
        <>
            <a
                className="breadcrumb-link"
                href={`${props.currentRoot}${props.categoryPath}`}
            >
                <span>{props.searchResponse?.data?.categoryName}</span>
            </a>
            <span className="back-slash">{'>'}</span>
            <a
                className="breadcrumb-link"
                href={`${props.currentRoot}${props.subCategoryPath}`}
            >
                <span>{props.searchResponse?.data?.subCategoryName}</span>
            </a>
            <span className="back-slash">{'>'}</span>
        </>
    );
};
